import { Payload } from 'vuex';

import { FINISH_READY_BACKEND, CHECK_READY_BACKEND } from './actionsTypes';

type ActionFnBool = (action: Payload) => boolean;

export const matchActionType =
	(type: string): ActionFnBool =>
	(action: Payload): boolean =>
		action.type === type;
export const matchActionTypeEndsWith =
	(type: string): ActionFnBool =>
	(action: Payload): boolean =>
		action.type.endsWith(type);
export const matchActionTypeEndsWithAndApp =
	(appName: string, type: string): ActionFnBool =>
	(action: Payload): boolean =>
		action.type.endsWith(type) && action.type.includes(appName);
export const getFRBActionType = (appName: string): string => `${appName}-${FINISH_READY_BACKEND}`;
export const getCRBActionType = (appName: string): string => `${appName}-${CHECK_READY_BACKEND}`;

export { FINISH_READY_BACKEND, CHECK_READY_BACKEND };
